/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";
import { useState } from "react";
import dayjs from "dayjs";

// @mui material components
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import StyledDatePicker from "components/DateTimePicker/styledDatePicker";

// NewUser page components
import FormField from "components/FormField";
import MDTypography from "components/MDTypography";

function CicloEdit({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { nombre, fecha_inicio, fecha_fin } = formField;
  const {
    nombre: nombreV,
    fecha_inicio: fecha_inicioV,
    fecha_fin: fecha_finV,
  } = values;

  const [openInicio, setOpenInicio] = useState(false);
  const [openFin, setOpenFin] = useState(false);

  const inicioDMY = fecha_inicioV
    ? dayjs(fecha_inicioV).format("DD/MM/YYYY")
    : "";
  const finDMY = fecha_finV ? dayjs(fecha_finV).format("DD/MM/YYYY") : "";

  return (
    <MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <FormField
              label={nombre.label}
              type={nombre.type}
              name={nombre.name}
              value={nombreV}
              error={errors.nombre && touched.nombre}
              success={nombreV?.length > 0 && !errors.nombre}
              noMarginBottom
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <MDTypography variant="button" fontWeight="bold">
              {fecha_inicio.label}
            </MDTypography>
            <TextField
              fullWidth
              name={fecha_inicio.name}
              value={inicioDMY}
              onClick={() => setOpenInicio(true)}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setOpenInicio(true)}>
                      <Icon>calendar_today</Icon>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(errors.fecha_inicio && touched.fecha_inicio)}
              helperText={
                errors.fecha_inicio && touched.fecha_inicio
                  ? errors.fecha_inicio
                  : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <MDTypography variant="button" fontWeight="bold">
              {fecha_fin.label}
            </MDTypography>
            <TextField
              fullWidth
              name={fecha_fin.name}
              value={finDMY}
              onClick={() => setOpenFin(true)}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setOpenFin(true)}>
                      <Icon>calendar_today</Icon>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(errors.fecha_fin && touched.fecha_fin)}
              helperText={
                errors.fecha_fin && touched.fecha_fin ? errors.fecha_fin : ""
              }
            />
          </Grid>
        </Grid>

        <StyledDatePicker
          open={openInicio}
          onClose={() => setOpenInicio(false)}
          value={inicioDMY}
          onChange={(dmy) => {
            const iso = dayjs(dmy, "DD/MM/YYYY").format("YYYY-MM-DD");
            setFieldValue(fecha_inicio.name, iso, true);
          }}
        />

        <StyledDatePicker
          open={openFin}
          onClose={() => setOpenFin(false)}
          value={finDMY}
          onChange={(dmy) => {
            const iso = dayjs(dmy, "DD/MM/YYYY").format("YYYY-MM-DD");
            setFieldValue(fecha_fin.name, iso, true);
          }}
        />
      </MDBox>
    </MDBox>
  );
}

// typechecking props for UserInfo
CicloEdit.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default CicloEdit;
